<template>
  <el-container direction="vertical" style="height: 100vh;">
    <Header></Header>
    <el-container direction="horizontal">
      <slot name="sidebar"></slot>
      <slot name="main"></slot>
    </el-container>
  </el-container>
</template>

<script>
import Header from '@/components/Header';

export default {
  components: {
    Header,
  },
};
</script>
